import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultValue = {
  breakpointName: 'default',
  isEditingForAllDevices: true
};
export const BreakpointContext = /*#__PURE__*/createContext(defaultValue);
function BreakpointContextProvider({
  children,
  breakpointName,
  isEditingForAllDevices = false
}) {
  return /*#__PURE__*/_jsx(BreakpointContext.Provider, {
    value: {
      breakpointName,
      isEditingForAllDevices
    },
    children: children
  });
}
export function useBreakpointContext() {
  const context = useContext(BreakpointContext);
  return Object.assign({}, context, {
    isDefaultBreakpoint: context.breakpointName === 'default',
    isMobileBreakpoint: context.breakpointName === 'mobile'
  });
}
export default BreakpointContextProvider;